<template>
    <div :class="classes">
        <header-block></header-block>
        <back-logo></back-logo>

        <transition name="fade" mode="out-in" :duration="{enter: 500, leave: 100}" appear @after-leave="onAfterLeave">
            <router-view></router-view>
        </transition>

        <upper-top></upper-top>
    </div>
</template>

<script>
    import 'babel-polyfill'
    import {mapState, mapActions, mapGetters} from 'vuex'
    import store from '../store/';
    import router from '../router';
    import _throttle from 'lodash/throttle'
    import {detectOS, eventBus} from "../utils/shared";
    let MobileDetect = require('mobile-detect');
    let md = new MobileDetect(navigator.userAgent);

    export default {
        store,
        router,
        data: function () {
            return {
                routeClass: '',
                orientation: '',
                pageCanInvert: false,
                osClasses: '',
                seoTitle: null,
                seoDescription: null,
                seoKeywords: null,
            }
        },
        computed: {
            classes() {
                document.body.className = this.osClasses +
                    (this.orientation === 'landscape' ? ' orient-landscape' : '') +
                    (this.orientation === 'portrait' ? ' orient-portrait' : '') +
                    (this.pageCanInvert && this.isInvertTheme ? ' theme--invert' : '') +
                    (this.menuOpened ? ' menu-opened' : '')
                ;

                return [
                    'wrapper wrapper-loaded',
                    this.routeClass,
                ]
            },

            ...mapState({
                menuOpened: state => state.ui.menuOpened
            }),
            ...mapGetters('ui', [
                'isInvertTheme',
                'seo',
            ]),
        },
        created() {
            this.isMobile()
            this.isTouch()
        },
        mounted() {
            this.initSeoElems()
            this.canAutoplay()
            window.addEventListener('load', _throttle(this.onResize, 30))
            window.addEventListener('resize', _throttle(this.onResize, 30))
            this.subscribeOnRoute();
            this.onRoute()
        },
        methods: {
            isMobile() {
                this.osClasses = detectOS()
                this.$store.commit('ui/isMobile', this.osClasses.indexOf('device-mobile') !== -1)
            },
            isTouch() {
                this.$store.commit('ui/isTouch', window.matchMedia('(any-pointer: coarse)').matches)
            },
            canAutoplay() {
                let value = true

                if (md.mobile() && md.is('iOS') && md.version('iOS') < 10) {
                    value = false
                } else if (md.version('Chrome') && md.version('Chrome') < 53) {
                    value = false
                }

                this.$store.commit('ui/canAutoplay', value)
            },
            onResize() {
                // debugger
                this.orientation = window.outerWidth > window.outerHeight
                    ? 'landscape'
                    : 'portrait'
            },
            subscribeOnRoute() {
                eventBus.$on('route.changed', () => {
                    let routeClasses = {
                        home: 'wrapper-index',
                        'home-detail': 'wrapper-single-home',
                        editors: 'wrapper-editors',
                        contacts: 'wrapper-contacts',
                        'our-story': 'wrapper-our-story',
                        featured: 'wrapper-featured-works',
                        features: 'wrapper-featured-works',
                        'featured-reel': 'wrapper-featured-reel',
                        'featured-detail': 'wrapper-featured-detail',
                        'editor-reel': 'wrapper-single-editor',
                        'editor-detail': 'wrapper-single-editor wrapper-single-editor-detail',
                        news: 'wrapper-news',
                        'news-detail': 'wrapper-news',
                    }

                    this.routeClass = routeClasses[this.$route.name] || '';
                    this.pageCanInvert = ['home', 'editors'].indexOf(this.$route.name) !== -1

                    console.log(this.$route);
                    this.toggleHeartbeat()
                })
            },
            onRoute() {
                eventBus.$emit('route.changed');
            },
            ...mapActions({
                toggleHeartbeat: 'ui/toggleHeartbeat',
                closeMenu: 'ui/closeMenu',
            }),
            onAfterLeave() {
                //console.log('app: after-leave')
                this.closeMenu()
                this.onRoute()
                this.$root.$emit('triggerScroll')
            },
            initSeoElems() {
                this.seoTitle = document.querySelector('head title')
                this.seoDescription = document.querySelector('head meta[name=description]')
                this.seoKeywords = document.querySelector('head meta[name=keywords]')
            },
            onSeo(new_, old_) {
                //debugger

                if (this.seoTitle) {
                    this.seoTitle.innerText = new_.title
                }

                if (this.seoDescription) {
                    this.seoDescription.setAttribute('content', new_.description)
                }

                if (this.seoKeywords) {
                    this.seoKeywords.setAttribute('content', new_.keywords)
                }
            }
        },
        watch: {
            'seo': 'onSeo',
        },
    }
</script>


<style>
    .wrapper-index .headlineBackNavLinkWrapper,
    .wrapper-editors .headlineBackNavLinkWrapper,
    .wrapper-contacts .headlineBackNavLinkWrapper,
    .wrapper-our-story .headlineBackNavLinkWrapper,
    .wrapper-news .headlineBackNavLinkWrapper {
        display: none;
    }

    .wrapper-editors .sliderVideoInfoWrapper {
        opacity: 0 !important;
    }

    .fade-enter-active {
        transition: 0.5s opacity ease;
    }

    .fade-leave-active {
        transition: 0.01s opacity ease;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
    {
        opacity: 0;
    }
</style>
